import React, { useEffect, useRef, useState } from 'react'

const formatSalonLabel = (salon) => {
  const firstName = salon?.name ? salon.name.split(' ')[0] : 'Salon'
  return salon?.city ? `${firstName} — ${salon.city}` : firstName
}

const SalonBranchDropdown = ({
  salons = [],
  selectedSalon,
  onSelect,
  className = '',
  size = 'md',
}) => {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [open])

  if (!salons.length || salons.length <= 1) return null

  const buttonSize =
    size === 'sm'
      ? 'text-xs px-3 py-2 gap-1.5'
      : 'text-sm px-3.5 py-2 gap-2'

  return (
    <div ref={rootRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center rounded-full border border-purple-100 bg-gradient-to-r from-purple-50/90 to-pink-50/80 text-gray-800 font-semibold shadow-sm hover:shadow-md hover:border-purple-200 transition-all duration-200 ${buttonSize} ${
          className.includes('w-full') ? 'w-full justify-between max-w-none' : 'max-w-[220px] sm:max-w-[260px]'
        }`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Choose salon branch"
      >
        <span className="w-6 h-6 rounded-full bg-white border border-purple-100 flex items-center justify-center shrink-0 text-purple-600">
          <i className="fas fa-map-marker-alt text-[10px]" />
        </span>
        <span className="truncate">{formatSalonLabel(selectedSalon)}</span>
        <i className={`fas fa-chevron-down text-[10px] text-purple-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open ? (
        <div className="absolute left-0 top-[calc(100%+8px)] z-[60] min-w-[240px] max-w-[320px] rounded-2xl border border-gray-100 bg-white shadow-xl overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100 bg-gradient-to-r from-purple-50 to-pink-50">
            <p className="text-[11px] font-bold uppercase tracking-wider text-purple-600">Select branch</p>
            <p className="text-xs text-gray-500 mt-0.5">Choose your preferred location</p>
          </div>
          <ul className="py-1.5 max-h-64 overflow-y-auto" role="listbox">
            {salons.map((salon) => {
              const active = selectedSalon?.id === salon.id
              return (
                <li key={salon.id}>
                  <button
                    type="button"
                    role="option"
                    aria-selected={active}
                    onClick={() => {
                      if (salon.id !== selectedSalon?.id) onSelect?.(salon)
                      setOpen(false)
                    }}
                    className={`w-full text-left px-4 py-3 flex items-start gap-3 transition ${
                      active
                        ? 'bg-purple-50 text-purple-900'
                        : 'hover:bg-gray-50 text-gray-800'
                    }`}
                  >
                    <span
                      className={`mt-0.5 w-5 h-5 rounded-full border flex items-center justify-center shrink-0 ${
                        active ? 'border-purple-500 bg-purple-500 text-white' : 'border-gray-300'
                      }`}
                    >
                      {active ? <i className="fas fa-check text-[9px]" /> : null}
                    </span>
                    <span className="min-w-0">
                      <span className="block font-semibold text-sm truncate">{salon.name}</span>
                      {salon.city ? (
                        <span className="block text-xs text-gray-500 mt-0.5">{salon.city}</span>
                      ) : null}
                    </span>
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      ) : null}
    </div>
  )
}

export default SalonBranchDropdown
